export const MEDIA_FEATURE_KEY = 'media';
